import React from "react";
import CartSummarySkeleton from "./CartSummarySkeleton";
import CartItemSkeleton from "./CartListSkeleton";

const CartTableDataSkeleton: React.FC = () => {
  return (
    <>
      <div
        className="grid grid-cols-3
              gap-10 max-md:gap-6 max-lg:grid-cols-1 items-start"
      >
        <div className="col-span-2 max-lg:col-auto">
          <div className="relative flex flex-col justify-between h-full">
            <div>
              <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-[#91DBE7] py-4 mb-4 max-md:hidden">
                <div className="h-6 w-10 skeleton !rounded-md"></div>
                <div className="h-6 w-10 skeleton !rounded-md"></div>
                <div className="h-6 w-10 skeleton !rounded-md"></div>
                <div className="h-6 w-10 skeleton !rounded-md"></div>
              </div>
              <div className="hidden max-md:block">
                <div className="flex items-center justify-between text-xl">
                  <span className="skeleton w-20 h-7 max-md:h-6 max-md:!rounded-md ml-1 text-lg text-primary text-start block"></span>
                  <span className="skeleton w-28 h-7 max-md:h-6 max-md:!rounded-md ml-1 text-lg text-primary text-start block"></span>
                </div>
              </div>
              <div>
                {[1, 2, 3].map((item) => {
                  return <CartItemSkeleton key={item} />;
                })}
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex flex-col mb-3 gap-1">
                <div className="h-6 w-20 skeleton !rounded-md"></div>
                <div className="h-6 w-28 skeleton !rounded-md"></div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="h-8 w-40 skeleton !rounded-md"></div>
              </div>
            </div>
          </div>
        </div>
        <CartSummarySkeleton />
      </div>
    </>
  );
};

export default CartTableDataSkeleton;
